import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

import {
    FaHome,
    FaClipboardList,
    FaMicrochip,
    FaExclamationTriangle,
    FaBolt,
    FaChartBar,
    FaCog,
    FaTimes,
    FaWhatsapp
} from "react-icons/fa";

import { getSupportConfig } from "../services/config";

import "../styles/sidebar.css";

export default function Sidebar({

    menuOpen,
    setMenuOpen

}) {

    const [supportNumber, setSupportNumber] = useState(null);
    const [supportError, setSupportError] = useState(false);

    useEffect(() => {

        getSupportConfig()
            .then(res => setSupportNumber(res.data.whatsapp))
            .catch((err) => {

                setSupportNumber(null);
                setSupportError(true);

                console.warn(
                    "Support button is disabled: couldn't load /api/config/support.",
                    "Most likely cause: SUPPORT_WHATSAPP_NUMBER isn't set in the backend .env.",
                    err.response?.status ? `(status ${err.response.status})` : err.message
                );

            });

    }, []);

    function openSupport() {

        if (!supportNumber) return;

        // wa.me wants digits only (no +, spaces, or dashes)
        const digits = supportNumber.replace(/\D/g, "");

        window.open(
            `https://wa.me/${digits}`,
            "_blank",
            "noopener,noreferrer"
        );

    }

    return (

        <>

            <div className={menuOpen ? "sidebar open" : "sidebar"}>

                <div className="sidebarHeader">

                    <div className="logo">
                        CercaTrova
                        <span>SOLAR</span>
                    </div>

                    <button
                        className="closeButton"
                        onClick={() => setMenuOpen(false)}
                    >
                        <FaTimes />
                    </button>

                </div>

                <ul>

                    <li>
                        <NavLink
                            to="/"
                            className={({ isActive }) => isActive ? "active" : ""}
                            onClick={() => setMenuOpen(false)}
                        >
                            <FaHome />
                            <span>Dashboard</span>
                        </NavLink>
                    </li>

                    <li>
                        <NavLink
                            to="/specs"
                            className={({ isActive }) => isActive ? "active" : ""}
                            onClick={() => setMenuOpen(false)}
                        >
                            <FaClipboardList />
                            <span>Inverter Specs</span>
                        </NavLink>
                    </li>

                    <li>
                        <NavLink
                            to="/devices"
                            className={({ isActive }) => isActive ? "active" : ""}
                            onClick={() => setMenuOpen(false)}
                        >
                            <FaMicrochip />
                            <span>My Devices</span>
                        </NavLink>
                    </li>

                  <li>
    <NavLink
        to="/alerts"
        className={({ isActive }) => isActive ? "active" : ""}
        onClick={() => setMenuOpen(false)}
    >
        <FaExclamationTriangle />
        <span>Alerts</span>
    </NavLink>
</li>

                    <li>
                        <a href="#">
                            <FaBolt />
                            <span>Energy</span>
                        </a>
                    </li>

                    <li>

                        <NavLink
                            to="/reports"
                            className={({ isActive }) => isActive ? "active" : ""}
                            onClick={() => setMenuOpen(false)}
                        >

                            <FaChartBar />

                            <span>Reports</span>

                        </NavLink>

                    </li>

                    <li>
                        <NavLink
                            to="/settings"
                            className={({ isActive }) => isActive ? "active" : ""}
                            onClick={() => setMenuOpen(false)}
                        >
                            <FaCog />
                            <span>Settings</span>
                        </NavLink>
                    </li>

                </ul>

                <button
                    className="supportButton"
                    onClick={openSupport}
                    disabled={!supportNumber}
                    title={
                        supportNumber
                            ? "Chat with us on WhatsApp"
                            : supportError
                            ? "Support isn't set up yet (see browser console)"
                            : "Loading..."
                    }
                >
                    <FaWhatsapp />
                    <span>Support</span>
                </button>

            </div>

            {menuOpen && (
                <div
                    className="sidebarOverlay"
                    onClick={() => setMenuOpen(false)}
                />
            )}

        </>

    );

}
